import {
  ISearchRequest,
  ListProductsParams
} from "../api/products.api";

const generateListProductsParams = (data: ISearchRequest): ListProductsParams => {
  return {
    pagination: {
      offset: 0,
      limit: 100,
      page: 0,
      sort: [ [ "description", "DESC" ] ]
    },
    filters: { $or: [ { description: { $like: `%${data}%` } }, { partNumber: { $like: `%${data}%` } } ] }
  };
};

export default generateListProductsParams;